import React from 'react';
import { arrivalLineColor, closureLineColor } from '../../../constants/colors';
import AdmIntervalChartWrapper from '../adm_shared/AdmIntervalChartWrapper';

export default function AdmArrivalClosureChart(props) {
  const { arrival, closure, increment, d0_date, d2_date } = props;

  return (
    <AdmIntervalChartWrapper
      title='Defect Arrival / Closure Prediction'
      arrival={arrival}
      closure={closure}
      increment={increment}
      d0_date={d0_date}
      d2_date={d2_date}
      arrivalColor={arrivalLineColor}
      closureColor={closureLineColor}
      chartHeight='30vw'
      showArrival={true}
      showClosure={true}
    />
  );
}
